import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { WindowShimModule } from '®shared/window-shim';

import { ListStatusPanelModule } from '../list-status-panel';

import { StickyFooterBarComponent } from './sticky-footer-bar.component';

@NgModule({
  imports: [CommonModule, WindowShimModule, ListStatusPanelModule],
  declarations: [StickyFooterBarComponent],
  exports: [StickyFooterBarComponent],
})
export class StickyFooterBarModule {}
